<template>
  <div class="header-top-nav">
    <ul class="ul-header-menu-top-nav">
      <li class="li-header-menu-top-nav-item float-l" v-if="!token || !userInfo">
        <span>
          <span>Hi,欢迎来到科润</span>
        </span>
        <span class="margin-l-15">
          <a :href="'../login/login.html?' + toUrl">登录</a>
        </span>
        <span class="margin-l-15">
          <a href="../login/register.html">免费注册</a>
        </span>
      </li>
      <li class="li-header-menu-top-nav-item float-l" v-if="token && userInfo">
        <span>
          <span>Hi,</span>
          <a href="../center-index.html">{{ userInfo.user_name }}</a>
        </span>
        <span class="margin-l-15">
          <a href="../center-trade.html?modelType=7">
            积分
            <span>{{ userInfo.credits }}</span>
          </a>
        </span>
        <span class="margin-l-15">
          <a href="../center-setting.html?key=8">
            消息
            <span>{{ msgCount }}</span>
          </a>
        </span>
        <span class="margin-l-15">
          <a href="javascript:void(0);" @click="exitToLogin()">退出</a>
        </span>
      </li>
      <li class="li-header-menu-top-nav-item float-r">
        <a href="javascript:void(0);" @click="toNextPageIsLogin('../center-setting.html')">个人设置</a>
      </li>
      <li class="li-header-menu-top-nav-item float-r margin-r-15">
        <a href="javascript:void(0);" @click="toNextPageIsLogin('../center-sourcing.html')">我的寻源</a>
      </li>
      <li class="li-header-menu-top-nav-item float-r margin-r-15">
        <a href="javascript:void(0);" @click="toNextPageIsLogin('../center-trade.html')">我的交易</a>
      </li>
      <li class="li-header-menu-top-nav-item float-r margin-r-15">
        <a href="javascript:void(0);" @click="toNextPageIsLogin('../center-index.html')">个人中心</a>
      </li>
      <li class="li-header-menu-top-nav-item float-r margin-r-15">
        <a href="../index.html">科润首页</a>
      </li>
    </ul>
  </div>
</template>
<script>
import { loadEShopAPiWithToken } from '../../https/loadData'
import eshopAPI from '../../api/eshopAPI'
import xy_config from '../../config/xy_config'
export default {
  name: 'HeaderTopNav',
  mounted () {
    console.log(window)
    const _that = this
    setInterval(function () {
      if (_that.token) {
        _that.getMsgCount()
      }
    }, 10000)
  },
  data () {
    return {
      msgCount: 0
    }
  },
  computed: {
    toUrl () {
      return 'to=' + escape(window.location.href)
    },
    token () {
      return this.$store.getters.token
    },
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  watch: {
    token () {
      if (this.token) {
        this.getMsgCount()
      }
    }
  },
  methods: {
    toNextPageIsLogin (url) {
      if (this.$cookie.get(xy_config.cookieToken)) {
        // 跳转页面
        window.location.href = url
      } else {
        // 跳转登录页面
        window.location.href = '../login/login.html?to=' + escape(url)
      }
    },
    exitToLogin () {
      // 退出,删除cookie 刷新页面
      this.$cookie.delete(xy_config.cookieToken)
      window.location.reload()
    },
    async getMsgCount () {
      const mParam = {}
      mParam['data[sys]'] = 'sp'
      const res = await loadEShopAPiWithToken(eshopAPI.getnewmessagecount, mParam)
      if (res && String(res.code === '0')) {
        this.msgCount = res.data
      }
    }
  }
}
</script>
<style lang="less" scoped>
.header-top-nav {
  min-width: 1190px;
  position: relative !important;
  background: #f2f2f2;
  z-index: 99;
  border-bottom: 1px solid #e5e5e5;
  height: 32px;
  overflow: hidden;
  margin: 0 auto;

  .ul-header-menu-top-nav {
    min-width: 1190px;
    width: 1190px;
    margin: 0 auto;
    position: relative;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    color: #999;
    .li-header-menu-top-nav-item {
      cursor: pointer;
      height: 32px;
      line-height: 32px;
    }
    .float-l {
      float: left;
    }
    .float-r {
      float: right;
    }
    .margin-r-15 {
      margin-right: 15px;
    }
    .margin-l-15 {
      margin-left: 15px;
    }
    .li-header-menu-top-nav-item a {
      color: #999;
    }
    .li-header-menu-top-nav-item a:hover {
      color: #f13a58;
    }
  }
}
</style>